export default __webpack_public_path__ + "static/media/milestone 2200.5849fe38.svg";